import { type QueryFunctionContext, useQuery } from "@tanstack/react-query";
import type { AxiosInstance } from "axios";
import { useApi } from "@/core/api";
import type { PayrollStatementNotificationState } from "@/payroll/pay-breakdown/payroll-statement-notifications/types";
import {
  payrollStatementNotificationsKey,
  payrollStatementNotificationsPath,
} from "./keys";

export const payrollStatementNotificationsQueryOptions = (
  api: AxiosInstance,
  businessId: string | null,
  periodStart: string | null,
) => ({
  queryKey: payrollStatementNotificationsKey(businessId, periodStart),
  queryFn: ({ signal }: QueryFunctionContext) => {
    if (!businessId || !periodStart) {
      throw new Error("Pay period is required");
    }

    return api
      .get(payrollStatementNotificationsPath(businessId, periodStart), {
        signal,
      })
      .then((res) => res.data as PayrollStatementNotificationState);
  },
  staleTime: 0,
  refetchOnMount: "always" as const,
  refetchOnWindowFocus: true,
  refetchOnReconnect: true,
  refetchInterval: 30_000,
  retry: false,
});

export const useGetPayrollStatementNotifications = (
  businessId: string | null,
  periodStart: string | null,
) => {
  const api = useApi();

  return useQuery({
    ...payrollStatementNotificationsQueryOptions(api, businessId, periodStart),
    enabled: !!businessId && !!periodStart,
  });
};
